import { useFormContext, useController } from 'react-hook-form';
import { FreightConditionForm } from '@retail/freight/components';
import { useItemSearch } from '@retail/calculus/context';
import { useFetchGlobalItemUnits } from '@retail/freight/data-access';
import { Unit } from '@retail/products/types';
import { ConditionsNew } from '@retail/calculus/types';
import { AllConditionsFormValues } from '../allConditionsSchema';
import { InheritedConditionHint } from './InheritedConditionHint';

interface Props {
  supplierNumber: number;
  editCondition?: ConditionsNew;
}

export function FreightStep({ supplierNumber, editCondition }: Props) {
  const { control } = useFormContext<AllConditionsFormValues>();
  const itemController = useController({ name: 'item', control });

  const { data: globalItemUnitsDTO = [] } = useFetchGlobalItemUnits();
  const globalItemUnits = globalItemUnitsDTO.map(Unit.fromDto);

  const { mgItem } = useItemSearch({
    supplierId: supplierNumber,
    selectedMgItemNumber: itemController.field.value?.mgItemNumber,
  });
  const supplierItemPackages = mgItem?.getSupplierItem(supplierNumber)?.mgSupplierItemPackages ?? [];

  return (
    <>
      {editCondition && <InheritedConditionHint area="freight" condition={editCondition} />}
      <FreightConditionForm
        supplierItemPackages={supplierItemPackages}
        globalItemUnits={globalItemUnits}
      />
    </>
  );
}
